// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ErrorMessageText = function (x) {
    return x;
};
var tsBridgeErrorMessageText = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ErrorMessageText")("__brandErrorMessageText"));
    }
};
var writeErrorMessageText = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showErrorMessageText = Data_Show.showString;
var readErrorMessageText = Simple_JSON.readString;
var ordErrorMessageText = Data_Ord.ordString;
var newtypeErrorMessageText = {
    Coercible0: function () {
        return undefined;
    }
};
var makeErrorMessageText = ErrorMessageText;
var eqErrorMessageText = Data_Eq.eqString;
export {
    ErrorMessageText,
    makeErrorMessageText,
    unwrap,
    newtypeErrorMessageText,
    eqErrorMessageText,
    ordErrorMessageText,
    showErrorMessageText,
    readErrorMessageText,
    writeErrorMessageText,
    tsBridgeErrorMessageText
};
//# sourceMappingURL=index.js.map
